/**
 * Visor de un tablero estatico: iframe aislado con selector de periodo
 */
import { Body, Box, Button, Flexbox, Heading, Select, TableLoader } from "codekit";
import { useEffect, useState } from "react";

import { useLazyGetContentQuery } from "../../libs/redux/slices/Paramgen/Dashestx/dashestxApiSlice";

/**
 * Renderiza el tablero estatico seleccionado
 * @param {Object} props Propiedades del componente
 * @param {Object} props.dashboard Tablero elegido en la galeria
 * @param {Function} props.onBack Vuelve a la galeria
 */
const Visordas = ({ dashboard, onBack }) => {
  const [periodo, setPeriodo] = useState(dashboard.VERPERXX || "");
  const [getContent, { data: content, isFetching, isError }] = useLazyGetContentQuery();
  const dashboardUrl = content?.data?.VERURLXX;
  //El HTML ya no viene en la respuesta del API, asi que la espera real es la del
  //iframe bajando el archivo de S3 y armando su DOM: sin esto se veria en blanco.
  const [isFrameLoading, setIsFrameLoading] = useState(true);

  useEffect(() => {
    getContent({ DASHIDXX: dashboard.DASHIDXX, VERPERXX: periodo });
  }, [dashboard.DASHIDXX, periodo, getContent]);

  useEffect(() => setIsFrameLoading(true), [dashboardUrl]);

  const periodosOptions = (dashboard.PERIODOS || []).map((item) => ({ value: item, text: item }));

  //codekit Select entrega el contexto { option } en lugar de un evento nativo
  const handleChangePeriodo = (context) => setPeriodo(context.option.value);

  return (
    <Box spacing={4}>
      <Flexbox justifyContent="between" alignItems="center" gap={4}>
        <Heading variant="heading-6">{dashboard.DASHNOMX}</Heading>
        <Flexbox gap={2} alignItems="center">
          {periodosOptions.length > 1 && (
            <Select options={periodosOptions} value={periodo} onChangeValue={handleChangePeriodo} />
          )}
          <Button variant="secondary" size="m" type="button" icon="back-arrow" onClick={onBack}>
            Volver
          </Button>
        </Flexbox>
      </Flexbox>
      {isFetching && <TableLoader />}
      {isError && (
        <Body variant="body-2">No se pudo cargar el tablero de este periodo.</Body>
      )}
      {!isFetching && !isError && dashboardUrl && (
        //El navegador trae el HTML directo de S3 con una URL temporal; el API solo la firma.
        //El HTML lo genera un tercero: sin allow-same-origin no alcanza cookies ni sesion de CIMA.
        //El loader va encima y no en lugar del iframe, para que el tablero mida su alto real
        //desde el principio y las graficas no queden dimensionadas contra un alto de cero.
        //mt separa el iframe de la barra de titulo; los 16px que suma se descuentan del
        //alto para que el visor siga cabiendo en pantalla sin scroll propio
        <Box mt={4} style={{ position: "relative", height: "calc(100vh - 236px)" }}>
          {isFrameLoading && (
            <div style={{ position: "absolute", inset: 0, zIndex: 1 }}>
              <TableLoader />
            </div>
          )}
          <iframe
            title={dashboard.DASHNOMX}
            src={dashboardUrl}
            sandbox="allow-scripts"
            onLoad={() => setIsFrameLoading(false)}
            style={{ width: "100%", height: "100%", border: 0 }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Visordas;
